import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap';
import AOForm from '../../../shared/AOForm';
import '../style/SMSCode.css';

const inputs = ["no1", "no2", "no3", "no4", "no5", "no6"];

export default class SMSCode extends Component {
  constructor(props) {
    super();
    this.state = {
      smsCodeValue: ""
    };
     [
      'handleDeltSMS',
      'handleInput',
      'getSMSCode',
      'clearSMSCode'
    ].forEach((fn) => this[fn] = this[fn].bind(this));
  }

  getSMSCode = () => {
    let SMSCode = this.no1.value + this.no2.value + this.no3.value + this.no4.value + this.no5.value + this.no6.value;
    return SMSCode;
  }
  clearSMSCode = () => {
    inputs.forEach((item, index) => {
      this[item].value = "";
    });
    this.props.setConfmBtnDisable(false);
  }

  handleDeltSMS = (e) => {
    this.keyCode = e.nativeEvent.keyCode;
    const nodeItem = parseInt(e.target.getAttribute("data-item"), 10);
    if (this.keyCode === 8 && nodeItem !== 1 && !e.target.value) {
      this["no" + (nodeItem - 1)].focus();
    }
  }

  handleInput = (e) => {
    if (/[^\d]/.test(e.target.value)) {
      let v = e.target.value.replace(/[^\d]/g, '');
      e.target.value = v;
    } else if (this.keyCode !== 8) {
      let node = e.target;
      (node.nextSibling) ? node.nextSibling.focus() : node.focus();
    }
    let isClearVfCodeErr = false;
    if(this.state.smsCodeValue !== this.getSMSCode() && this.props.isDisplayErr){
      this.setState({smsCodeValue: this.getSMSCode()});
      isClearVfCodeErr = true;
    }
    
    (this.getSMSCode().length === 6) ? this.props.setConfmBtnDisable(true,isClearVfCodeErr) : this.props.setConfmBtnDisable(false,isClearVfCodeErr);
  }
  render() {
    const {
      content,
      SMSBtnEvt,
      disableSMSBtn,
      isDisplayErr,
      isDisplayImageCodeErr,
      inputErrMsg,
      imageSrc,
      imageCodeInputValue,
      handleImageCodeInput,
      handleGetImageCode,
      disableSMSinput
    } = this.props;
    let hideErrMsg = isDisplayErr ? "" : "hidden";
    return (
      <FormGroup className="smsCodeBody">
        
        <div className="imageCodeDiv">
            <div className='imageCode'><img src={imageSrc} onClick={handleGetImageCode}/></div>
            <div className='imageCodeTitle'>{content.imageCodeTitle}</div>
            <div className={"form-item imageci" + (isDisplayImageCodeErr ? " imagecodeinput-error" : "")}>
              <FormControl
                role="textbox"
                id="imageCodeInputID"
                aria-required={true}
                type=""
                inputRef={imageCodeInputValue}
                maxLength={4}
                onInput={handleImageCodeInput} 
                data-key={"image_code_input"}
                />
                {
                  isDisplayImageCodeErr &&
                  <div className={"logon-mobile-info " + isDisplayImageCodeErr ? "" : "hidden"}>
                    <div className={"icon icon-circle-delete icon-logon logon-input-info logon-input-err "}>
                        <span aria-hidden={isDisplayImageCodeErr} data-key={"logon_errPhnMsg"}>{inputErrMsg}</span>
                    </div> 
                  </div>
                }
            </div>

        </div>

        <div className="clearfix">
          <Button
            aria-pressed={false}
            aria-disabled={disableSMSBtn}
            data-key={"logon_btn_send"}
            bsStyle="info"
            onClick={SMSBtnEvt}
            disabled={disableSMSBtn}
          >
            {content.SMSBtnTxt}
          </Button>
          {this.props.timer}
        </div>

        
        <ControlLabel htmlFor="varifyCodeTitle1" data-key={"logon_varifyCode"}>{content.title}</ControlLabel>
        <div className="smsInputBody">{
          inputs.map((item, key) => {
            return (
                <FormControl
                  key={key}
                  id={"varifyCodeTitle" + (key + 1)}
                  aria-required={true}
                  aria-label={content.title + (key + 1)}
                  data-key={"logon_SMSCode_" + (key + 1)}
                  data-item={key + 1}
                  type="tel"
                  maxLength="1"
                  onInput={this.handleInput}
                  onKeyDown={this.handleDeltSMS}
                  disabled={disableSMSinput}
                  bsClass={"SMS-input" + (isDisplayErr ? " logon-phn-error" : "")}
                  inputRef={input => this[item] = input} />
            )})
        }</div>
        <div className={"logon-mobile-info " + hideErrMsg}>
            <div className={"icon icon-circle-delete icon-logon logon-input-info logon-input-err "}>
                <span aria-hidden={isDisplayErr} data-key={"logon_errPhnMsg"}>{inputErrMsg}</span>
            </div> 
        </div>

        
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Logon/components/SMSCode.js